import { useParams } from 'react-router-dom';

import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { IssuanceContributingItems } from 'codegen';

import { columns } from './lib';

export const IssuanceItemTable = ({
  expandedId,
  issuanceId,
  transactionId,
}: {
  expandedId?: number;
  issuanceId: number;
  transactionId?: number;
}) => {
  const { snapId } = useParams();
  const { data, loading } = useGetRequest<IssuanceContributingItems>({
    url: `/snaps/${snapId}/transactions/${transactionId}/issuances/${issuanceId}/items`,
    options: {
      ready: !!(expandedId && issuanceId && expandedId === issuanceId),
      refreshDeps: [expandedId, issuanceId],
    },
  });

  const dataSource = data?.items;

  return (
    <MilesTable
      size='small'
      rowKey='id'
      loading={loading}
      columns={columns}
      dataSource={dataSource}
    />
  );
};
